import "@/App.css";
import { useEffect, useMemo, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ModalContext } from "@/components/ModalContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProspectusModal from "@/components/ProspectusModal";
import EnquiryModal from "@/components/EnquiryModal";
import Home from "@/pages/Home";
import LearningJourney from "@/pages/LearningJourney";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  const [prospectusOpen, setProspectusOpen] = useState(false);
  const [enquiryProgram, setEnquiryProgram] = useState(null);

  const modals = useMemo(
    () => ({
      openProspectus: () => setProspectusOpen(true),
      openEnquiry: (program) => setEnquiryProgram(program),
    }),
    []
  );

  return (
    <ModalContext.Provider value={modals}>
      <BrowserRouter>
        <ScrollManager />
        <div className="flex min-h-screen flex-col">
          <Header />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/learning-journey" element={<LearningJourney />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </div>
          <Footer />
        </div>
        <ProspectusModal open={prospectusOpen} onOpenChange={setProspectusOpen} />
        <EnquiryModal program={enquiryProgram} onClose={() => setEnquiryProgram(null)} />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </ModalContext.Provider>
  );
}
